import React from 'react';
import { FooterNavList, FooterNavListItem } from './FooterBottomNav.styles';
import FooterNavlink from '@/components/footer/FooterNavlink/FooterNavlink';
import { Text } from '@/components/typography';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/router';
import FlagEnUSIcon from '@/components/icons/FlagEnUSIcon/FlagEnUSIcon';
import FlagPtBrIcon from '@/components/icons/FlagPtBrIcon/FlagPtBrIcon';

export interface FooterBottomNavProps {
  bottomNavMenu: {
    sitemap: string;
    privacyPolicy: string;
  };
}

const FooterBottomNav = ({ bottomNavMenu, ...props }: FooterBottomNavProps) => {
  const t = useTranslations('Footer');
  const { locale, locales, route, ...router } = useRouter();
  const otherLocale = locales?.find((cur) => cur !== locale) as string;
  return (
    <FooterNavList>
      <FooterNavListItem>
        <FooterNavlink href={bottomNavMenu.sitemap}>
          <Text size="xs">Site Map</Text>
        </FooterNavlink>
      </FooterNavListItem>
      <FooterNavListItem separator />
      <FooterNavListItem>
        <FooterNavlink href={bottomNavMenu.privacyPolicy}>
          <Text size="xs">{t('Política de Privacidade')}</Text>
        </FooterNavlink>
      </FooterNavListItem>
      <FooterNavListItem separator />
      <FooterNavListItem>
        <FooterNavlink href={router.asPath} locale={otherLocale}>
          <Text size="xs" style={{ display: 'flex', alignItems: 'center', gap: '0.2rem' }}>
            {t('Language')}
            {locale === 'pt-BR' && <FlagEnUSIcon width={16} height={10} />}
            {locale === 'en' && <FlagPtBrIcon width={16} height={10} />}
          </Text>
        </FooterNavlink>
      </FooterNavListItem>
    </FooterNavList>
  );
};

export default FooterBottomNav;
